import { MenuItem } from '@material-ui/core';
import { FormikTextField } from '@superdispatch/forms';
import { useValueObserver } from '@superdispatch/hooks';
import { formatVehicleType } from '@superdispatch/sdk';
import { useFormikContext } from 'formik';
import { mapVehicleType, VALID_VEHICLE_TYPES } from '../../../data/VehicleDTO';

interface VehicleTypeFieldProps {
  name: string;
  make: string | null;
  disabled: boolean;
}

export function VehicleTypeField({
  name,
  make,
  disabled,
}: VehicleTypeFieldProps) {
  const { setFieldValue } = useFormikContext();

  useValueObserver(make, () => {
    setFieldValue(name, '');
  });

  return (
    <FormikTextField
      label="Type"
      name={name}
      select={true}
      fullWidth={true}
      disabled={disabled}
    >
      {VALID_VEHICLE_TYPES.map((type) => (
        <MenuItem key={type} value={type}>
          {formatVehicleType(mapVehicleType(type))}
        </MenuItem>
      ))}
    </FormikTextField>
  );
}
